/**
 * Conversion options of a tool, read from the form fields of the page
 * (names and values are the API's job options: convertmode, convertparam,
 * ocrfirstlang, ocrsecondlang; the combined file name is `filename`).
 */

import { find, findAll } from "../lib/dom";

const DEFAULT_COMBINED_NAME = "combined";

export function readOptions(scope: ParentNode): Record<string, string> {
  const container = find(scope, "[data-options]", HTMLElement);
  if (container === null) return {};
  const entries: [string, string][] = [];
  for (const radio of findAll(
    container,
    "input[type=radio]",
    HTMLInputElement,
  )) {
    if (radio.checked) entries.push([radio.name, radio.value]);
  }
  for (const select of findAll(container, "select", HTMLSelectElement)) {
    entries.push([select.name, select.value]);
  }
  return Object.fromEntries(entries);
}

/** Name of the combined PDF (without .pdf; the server makes it safe). */
export function readFilename(scope: ParentNode): string {
  const input = find(scope, "input[name=filename]", HTMLInputElement);
  const name = input?.value.trim().replace(/\.pdf$/i, "") ?? "";
  return name === "" ? DEFAULT_COMBINED_NAME : name;
}

/** PDF to Word: the OCR languages matter only in the OCR mode. */
export function initOptions(scope: ParentNode): void {
  const block = find(scope, "[data-ocr-languages-block]", HTMLElement);
  if (block === null) return;
  const radios = findAll(
    scope,
    "[data-options] input[type=radio]",
    HTMLInputElement,
  );
  const update = (): void => {
    block.hidden = !radios.some(
      (radio) =>
        radio.checked && radio.hasAttribute("data-shows-ocr-languages"),
    );
  };
  for (const radio of radios) radio.addEventListener("change", update);
  update();
}

export function setOptionsDisabled(scope: ParentNode, disabled: boolean): void {
  const container = find(scope, "[data-options]", HTMLElement);
  if (container === null) return;
  for (const control of findAll(container, "input, select", HTMLElement)) {
    if (
      control instanceof HTMLInputElement ||
      control instanceof HTMLSelectElement
    ) {
      control.disabled = disabled;
    }
  }
}
